<template lang="pug">
v-stepper.quote-steps(
  alt-labels,
  elevation="0",
)
  v-stepper-header
    template(v-for="(quotes, leg, index) in quotesByLeg")
      v-stepper-step(:step="index + 1", editable) {{ getLegName(quotes) }}
      v-divider(v-if="index != (Object.keys(quotesByLeg).length - 1)")
  v-stepper-items
    template(v-for="(quotes, leg, index) in quotesByLeg")
      v-stepper-content(:step="index + 1")
        quote-comparation(:value="quotes", v-bind="{ entity, carriers }")
</template>

<style lang="scss" scoped>
.quote-steps {
  ::v-deep .v-stepper__wrapper {
    overflow-x: auto;
  }
}
</style>

<script>
import EntityMixin from '@/mixins';
import QuoteComparation from "@/components/Shipment/QuoteComparation.vue";

export default {
  mixins: [EntityMixin],
  components: {
    QuoteComparation,
  },
  props: {
    carriers: {
      type: Array,
      default: () => ([]),
    },
    entity: null,
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    key: 0,
  }),
  methods: {
    // This function assumes the quotes have a loaded leg
    // Use array and object destruct to get first quote from array name
    getLegName(quotes) {
      const [{ leg }] = quotes;
      const { name } = leg || {};
      return name || 'null';
    },
  },
  computed: {
    quotes() {
      return this.value || [];
    },
    quotesByLeg() {
      return _.groupBy(this.quotes, 'legId');
    },
  }
}
</script>
